import React from 'react';
import { motion } from 'framer-motion';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import PageHero from '../components/PageHero';
import { CASE_STUDIES } from '../data/caseStudies';
import CaseStudyCard from '../components/CaseStudyCard';
import FormulationFinder from '../components/FormulationFinder';

export default function Innovation() {
  return (
    <motion.main
      id="main"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
    >
      <Navigation />
      <PageHero
        kicker="Innovation"
        title="Get inspired"
        subtitle="Real formulations solving real challenges — tagged by product line and polymer substrate."
        variant="lab"
      />
      <div className="innovation-page-grid">
        {CASE_STUDIES.map((cs, i) => (
          <CaseStudyCard key={cs.id} study={cs} index={i} />
        ))}
      </div>
      <div className="finder-cta-sec" style={{ paddingBottom: 80 }}>
        <h2>Have a similar challenge?</h2>
        <p>Our applications engineers can develop a custom formulation within 72 hours.</p>
        <FormulationFinder triggerLabel="Start Formulation Finder" />
      </div>
      <Footer />
    </motion.main>
  );
}
